/**
 * Camera control module for PacMassive
 * Manages camera movement and position updates
 */

import * as THREE from "three";
import { getLocalPlayer, getLocalPlayerId, getPlayerMeshes } from "./gameState";
import { camera } from "./core";

// Camera control constants
export const CAMERA_LERP_FACTOR = 0.1;
export const CAMERA_HEIGHT = 8;
export const CAMERA_DISTANCE = 6;
export const DIRECTION_CHANGE_THRESHOLD = 0.1;

// Camera targets for smooth movement
export const cameraTargetPosition = new THREE.Vector3();
export const cameraTargetLookAt = new THREE.Vector3();

// Simple smoothing with minimal delay

/**
 * Update camera position and direction
 * Uses a simplified approach for more stable camera
 */
export function updateCamera(): void {
  const localId = getLocalPlayerId();
  const localPlayer = getLocalPlayer();
  if (!localId || !localPlayer) return;

  const localMesh = getPlayerMeshes()[localId];
  if (!localMesh) return;

  // Get current player position
  const position = localMesh.position.clone();

  // Calculate new camera target
  cameraTargetPosition.set(
    position.x,
    CAMERA_HEIGHT,
    position.z + CAMERA_DISTANCE
  );

  // Look at player
  cameraTargetLookAt.set(position.x, 0.4, position.z);

  // Apply smooth transitions with damping
  camera.position.lerp(cameraTargetPosition, CAMERA_LERP_FACTOR);
  camera.lookAt(cameraTargetLookAt);
}
